import { UserServiceArea } from "./UserServiceArea";

export const deliveryFulfillmentType = "delivery" as const;
export const pickupFulfillmentType = "pickup" as const;
export const shippingFulfillmentType = "shipping" as const;

type DeliveryFulfillmentType = typeof deliveryFulfillmentType;
type PickupFulfillmentType = typeof pickupFulfillmentType;
type ShippingFulfillmentType = typeof shippingFulfillmentType;

export type FulfillmentType =
  | DeliveryFulfillmentType
  | PickupFulfillmentType
  | ShippingFulfillmentType;

export interface ProductAvailability {
  availability: {
    delivery: {
      amounts: { label?: string; value?: string }[];
      offerCount: number;
    };
    pickup: {
      amounts: { label?: string; value?: string }[];
      offerCount: number;
    };
  };
  totalOfferCount: number;
}

export type Brand = {
  id: number;
  featureTier: string;
};

export type Dispensary = {
  id: number;
  distanceMi: number | null;
  featureTier: string;
  inStoreCartEnabled: boolean;
  maxDeliveryDurationMaximum: number | null;
  maxFee: number | null;
  maxOrderMinimum: number | null;
  name: string;
  path: string;
  slug: string;
  userServiceArea?: UserServiceArea;
};

export type MenuDeal = {
  finePrint: string;
  label: string;
  title: string;
};

export type Variant = {
  id: number;
  isInitialSelection: boolean;
  displayPrice: number;
  medical: boolean;
  menuDeal: MenuDeal | null;
  quantity: number;
  regularPrice: number;
  stockQuantity: number; // can this be null?
  unit: string;
};

export type LeaflyFulfillmentDetails = {
  brand: Brand | null;
  dispensary: Dispensary;
  menuItemId: number;
  name: string;
  onlineFulfillmentEnabled: boolean;
  productCategory: string;
  productId: number;
  strainId: number | null;
  variants: Variant[];
};

export type ShippingFulfillmentDetails = {
  affiliateUrl: string;
};

type BaseFulfillment = {
  isInitialSelection: boolean;
};
export type DeliveryFulfillmentResponse = BaseFulfillment & {
  details: LeaflyFulfillmentDetails | null;
  type: DeliveryFulfillmentType;
};
export type PickupFulfillmentResponse = BaseFulfillment & {
  details: LeaflyFulfillmentDetails | null;
  type: PickupFulfillmentType;
};
export type ShippingFulfillmentResponse = BaseFulfillment & {
  details: ShippingFulfillmentDetails | null;
  type: ShippingFulfillmentType;
};

export type FulfillmentResponse =
  | [
      DeliveryFulfillmentResponse,
      PickupFulfillmentResponse,
      ShippingFulfillmentResponse,
    ]
  | [];

export type LeaflyItems = {
  delivery: LeaflyFulfillmentDetails[];
  pickup: LeaflyFulfillmentDetails[];
};
